import { useMemo } from 'react';

import { selectManageAccessDraft, selectManageAccessInternalUsers } from '@/store/selectors/manageAccess';
import { setManageAccessDraftField } from '@/store/slices/manageAccess/manageAccessSlice';
import { usePersonPicker } from '@/hooks/shared/usePersonPicker';

export function useStepManageAccessOwners() {
  const { state, handlers } = usePersonPicker({
    selectDraft: selectManageAccessDraft,
    selectUsers: selectManageAccessInternalUsers,
    dispatchSetField: (dispatch, key, value) => dispatch(setManageAccessDraftField({ key, value })),
    primaryKey: 'ownerIds',
    exclusionKey: 'internalParticipantIds',
  });

  const selectedOwners = useMemo(
    () => state.selected.map((person) => ({ ...person, isYou: false })),
    [state.selected]
  );

  return {
    state: {
      selectedOwners,
      candidateOwners: state.candidates,
      searchValue: state.searchValue,
    },
    handlers: {
      handleSearchChange: handlers.handleSearchChange,
      handleRemoveOwner: handlers.handleRemove,
      handleAddOwner: handlers.handleAdd,
    },
  };
}
